// Shared client polling cadence for channels/DMs unread state + in-app
// notifications. Lives in lib/ so both modules/ (SidebarRail's rail data) and
// features/ (NotificationsProvider) can import one source of truth — features
// may not import modules/ under the one-way import rule.
export const POLL_INTERVAL = 3000;
